import React, {Component, ErrorInfo} from 'react'
import {createCorrelationId, reportClientError} from './observability'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  incidentId?: string
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {hasError: false}
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const incidentId = createCorrelationId()
    reportClientError(error, 'MegaPayCP ErrorBoundary', incidentId)
    setTimeout(() => {
      window.location.replace('/')
    }, 30000)
    this.setState({hasError: true, incidentId})
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className='d-flex min-vh-100 align-items-center justify-content-center p-5' dir='rtl'>
          <div className='text-center'>
            <h1 className='fs-2 fw-bold mb-4'>خطای پیش‌بینی‌نشده‌ای رخ داد</h1>
            <p className='text-muted mb-2'>صفحه تا چند لحظه‌ی دیگر دوباره بارگذاری می‌شود.</p>
            <p className='text-muted'>کد پیگیری: {this.state.incidentId}</p>
          </div>
        </main>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
